const emailValidator = (value: string): any => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(String(value).toLowerCase());
};

// must be MM/YYYY
export const monthYearValidation = (str: string): boolean => {
  const pattern = /^((0[1-9])|(1[012]))( \/ )(2[0-9]{3})$/g;
  return pattern.test(str);
};

export const cvvValidation = (str: string): boolean => {
  const pattern = /^[0-9]+$/g;
  return pattern.test(str);
};

export const urlValidator = (value: string): boolean => {
  const pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
  return pattern.test(String(value).toLowerCase());
};

export const validateNPI = (event: any): any => {
  const pattern = /^[0-9]+$/;
  if (pattern.test(event.target.value)) {
    return event.target.value.toString().slice(0, 10);
  } else {
    return '';
  }
};

export default emailValidator;
